import { render, staticRenderFns } from "./MyWebsiteImage.vue?vue&type=template&id=4d230ea6&scoped=true"
import script from "./MyWebsiteImage.vue?vue&type=script&lang=ts"
export * from "./MyWebsiteImage.vue?vue&type=script&lang=ts"
import style0 from "./MyWebsiteImage.vue?vue&type=style&index=0&id=4d230ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d230ea6",
  null
  
)

export default component.exports